import React from 'react';
import MyAccount from './MyAccount';
import {Row, Col} from 'react-bootstrap/lib/';

export default class Settings extends React.Component {

  constructor() {
    super();
  }

  componentWillMount () {

  }

  render() {
    return (
      <div className="topPaddingMd">
        <Row>
          <Col xs={12}>
            <MyAccount />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js